var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "level" }, [
      _c("div", { staticClass: "level-left" }, [
        _c("div", { staticClass: "level-item" }, [
          _c("p", { staticClass: "title is-4 is-spaced" }, [
            _vm._v("Manage " + _vm._s(_vm.typeStringPlural))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "level-right" }, [
        _c("div", { staticClass: "level-item" }, [
          _c("div", { staticClass: "field" }, [
            _c(
              "p",
              { staticClass: "control" },
              [
                _c("modal-add-suite", {
                  ref: "add",
                  attrs: {
                    "contact-type": _vm.typeString,
                    "meeting-id": _vm.meetingId
                  },
                  on: { editSuite: _vm.openEditSuite }
                })
              ],
              1
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [
      _c(
        "table",
        { staticClass: "table is-fullwidth table-with-data-labels" },
        [
          _c("thead", [
            _c("tr", [
              _c("th", { attrs: { scope: "col" } }, [
                _vm._v(_vm._s(_vm.typeString) + " Name")
              ]),
              _vm._v(" "),
              _c("th", { attrs: { scope: "col" } })
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.sortedSuites, function(suite) {
              return _c("tr", { key: suite.id }, [
                _c("td", { attrs: { "data-label": "Name" } }, [
                  _c(
                    "span",
                    { class: { missingContacts: !_vm.hasContacts(suite) } },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.getCompanySuiteName(
                              suite.name,
                              suite.company.name
                            )
                          )
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "has-text-right",
                    attrs: { "data-label": "" }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "button text-sm lg:text-xs is-outlined",
                        attrs: { title: "View Schedule" },
                        on: {
                          click: function($event) {
                            return _vm.$router.push({
                              name: "AdminViewSchedule",
                              params: { id: _vm.meetingId, suiteId: suite.id }
                            })
                          }
                        }
                      },
                      [_c("i", { staticClass: "fas fa-eye" })]
                    ),
                    _vm._v(" "),
                    _c("modal-edit-suite", {
                      ref: suite.id,
                      refInFor: true,
                      staticClass: "ml-2",
                      attrs: {
                        "suite-id": suite.id,
                        "contact-type": _vm.typeString,
                        "meeting-id": _vm.meetingId
                      },
                      on: { addSuite: _vm.openAddSuite }
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "button text-sm lg:text-xs is-danger is-outlined ml-2",
                        attrs: { title: "Delete" },
                        on: {
                          click: function($event) {
                            return _vm.deleteSuite(suite)
                          }
                        }
                      },
                      [_c("i", { staticClass: "far fa-trash-alt" })]
                    )
                  ],
                  1
                )
              ])
            }),
            0
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55cf20ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55cf20ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ManageSuites.vue
// module id = null
// module chunks = 